import type { IBaseControlSetting } from '~/presentation/reports/common/type';
import type { IItemSelectorConfig } from '../types';

import { Box, InlineGrid, Popover } from '@shopify/polaris';
import { WrapperItemInfoSection } from './ItemInfoSection';
import { ItemsSelector } from './ItemsSelector';
import type { ReactElement } from 'react';
import { useEffect } from 'react';

export interface GroupedSelectPopoverProps extends IBaseControlSetting {
  config?: IItemSelectorConfig;
  activator: ReactElement;
  popoverActive: boolean;
  togglePopoverActive: (active: boolean) => void;
  minHeight?: string;
  variant: 'action-list' | 'choice';
  fixed?: boolean;
}

export const GroupedSelectPopover: React.FC<GroupedSelectPopoverProps> = (props) => {
  const { activator, popoverActive, togglePopoverActive, minHeight, fixed } = props;

  useEffect(() => {
    if (!popoverActive) return;
    const popoverPane = document.querySelector('.Polaris-Popover__Pane.Polaris-Scrollable');
    if (popoverPane) {
      (popoverPane as HTMLElement).style.overflowY = 'hidden';
      (popoverPane as HTMLElement).style.overflowX = 'hidden';
    }
  }, [popoverActive]);

  return (
    <Popover
      active={popoverActive}
      activator={activator}
      onClose={() => togglePopoverActive(false)}
      fluidContent
      fullHeight
      fixed={fixed}
      preferredAlignment="right"
    >
      <Box width="600px" minHeight={minHeight}>
        <InlineGrid columns={{ xs: 2 }} gap={{ xs: '0' }}>
          <WrapperItemInfoSection control={props} popoverActive={popoverActive} />
          <ItemsSelector
            control={props}
            togglePopoverActive={togglePopoverActive}
            active={popoverActive}
          />
        </InlineGrid>
      </Box>
    </Popover>
  );
};
